import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'


Alpine.plugin(collapse)
Alpine.plugin(focus)

window.Alpine = Alpine

// import './components/rellax'
import './components/slideout'
import './components/video-slider'
// import './components/swiper'


Alpine.start();
